export default [
  {
    header: 'İstatistik Yönetimi',
  },
  {
    title: 'Enerji Analizleri',
    icon: 'TrendingUpIcon',
    children: [

      {
        title: 'Tüketim Verileri',
        route: 'dashboard-analytics',
      },
      {
        title: 'Enerji Performans Göstergesi',
        route: 'charts-apex-chart',
      },
      {
        title: 'Güç Analizörü Tanımlama',
        route: 'ui-typography',

      },
      {
        title: 'Cihaz Ekleme/Görüntüleme',
        route: { name: 'apps-invoice-edit', params: { id: 4987 } },
      },
      {
        title: 'Sayaç Ekleme Görüntüleme',
        route: { name: 'apps-invoice-add' },
      },

    ],
  },
  {
    title: 'Fatura Yönetimi',
    icon: 'DollarSignIcon',
    children: [
      /*
     {
        title: 'Tahsilat Özeti',
        route: 'btrans-tahsilatlar',
      },
      */

      /*
      {
        title: 'Fatura İşlemleri',
        route: 'ui-feather',
      },
      */
      {
        title: 'Aktif Enerji Faturaları',
        route: 'apps-e-commerce-wishlist',
      },
      {
        title: 'Tahsilat Özeti',
        route: 'form-repeater',
      },
      /*
      {
        title: ' Teminatları',
        route: 'apps-e-commerce-checkout',
      }, */
    ],
  },
  {
    title: 'Tüketim Analizleri',
    icon: 'BarChart2Icon',
    children: [
      {
        title: 'Günlük Tahmini Tüketim',
        route: 'pages-pricing',
      },
      {
        title: 'Tüketim Kıyaslamarı',
        route: 'apps-users-list',
      },
      {
        title: 'Kayıp-Kaçak İşlemleri',
        route: { name: 'apps-users-view', params: { id: 21 } },
      },

      {
        title: 'Dengesizlik Takibi',
        route: 'pages-blog-edit',
      },
    ],
  },
  /*
  {
    title: ' Sözleşmeler',
    icon: 'FileIcon',
    children: [

      {
        title: 'Talep Yöntemleri',
        route: '#',
      },

      {
        title: 'Müşteri Sözleşmeleri',
        route: 'pages-profile',
      },
      {
        title: 'Raporlar',
        route: '#',
      },

    ],
  }, */
]
